<script setup>
import { ref, computed } from 'vue';
import PageSpaceContact from './steps/PageSpaceContact.vue';
import Success from './steps/Success.vue';

const STEP = {
  CONTACT_FORM: 'CONTACT_FORM',
  SUCCESS: 'SUCCESS',
};

const currentStep = ref(STEP.CONTACT_FORM);

const stepComponent = new Map([
  [ STEP.CONTACT_FORM, { component: PageSpaceContact, next: STEP.SUCCESS } ],
  [ STEP.SUCCESS, { component: Success } ],
]);

const currentStepComponent = computed(() => stepComponent.get(currentStep.value));
</script>

<template>
  <component
    :is="currentStepComponent.component"
    class="container"
    @next-step="currentStep = currentStepComponent.next"
  />
</template>
